import { createDeployPluginHeadless } from '../../_shared/common/createDeployPluginHeadless';
import { TC_CAPABILITIES } from '../capabilities';
import { TC_FIELD_KEYS } from '../fields';
import { TC_MODULES } from '../modules';
import {
  buildTrainingClusterDisplayDescriptors,
  buildTrainingClusterResourceConfigs,
  pickTrainingClusterPresetFields,
  serializeTrainingClusterApiBody,
} from './projections';
import { type TcApiPayload, type TcPluginSpec, TcPluginSpecSchema } from './schema';
import { tcFromForm, tcGetInitialFormValues, tcToForm } from './spec';
import { assertTrainingClusterSubmitReady } from './validateSubmit';

/** modules 浅拷贝与历史 assertPluginLayout 入参一致，避免 readonly 能力绑定引用被改写 */
const tcModulesForLayout = TC_MODULES.map((module) => ({
  ...module,
  capabilities: [...module.capabilities],
  fields: [...module.fields],
  presetCheckFields: module.presetCheckFields ? [...module.presetCheckFields] : undefined,
}));

export const tcHeadless = createDeployPluginHeadless<TcPluginSpec, TcApiPayload, (typeof TC_FIELD_KEYS)[number]>({
  code: 'TrainingCluster',
  fieldKeys: TC_FIELD_KEYS,
  modules: tcModulesForLayout,
  capabilities: [...TC_CAPABILITIES],
  schema: TcPluginSpecSchema,
  fromForm: tcFromForm,
  toForm: tcToForm,
  getInitialFormValues: tcGetInitialFormValues,
  assertSubmitReady: assertTrainingClusterSubmitReady,
  projectionProfile: {
    profile: 'sku-capable',
    projections: {
      apiBody: serializeTrainingClusterApiBody,
      skuPreset: pickTrainingClusterPresetFields,
      buildDisplayDescriptors: buildTrainingClusterDisplayDescriptors,
      skuResources: buildTrainingClusterResourceConfigs,
    },
  },
  migrations: {},
});

/** 训练集群 SKU/下单统一管道。 */
export const tcPipeline = tcHeadless.pipeline;

export type { TcApiPayload, TcPluginSpec } from './schema';
export {
  buildTrainingClusterSharedVolumes,
  buildTrainingClusterSpec,
  findDuplicateTrainingSharedVolumeMountPath,
  getTrainingClusterImage,
  getTrainingClusterSharedVolumes,
} from './trainingClusterSpec';
export type { TrainingClusterNetwork, TrainingClusterNic, TrainingClusterSpec } from './trainingClusterSpec';
